import { useCallback } from "react";

// No-op implementation for web — expo-notifications uses localStorage
// which is unavailable during SSR (static rendering in Node.js).
export function useFCMNotifications(_userLoggedIn: boolean) {
  const refreshToken = useCallback(async () => false, []);
  return { refreshToken };
}
